module.exports = __webpack_public_path__ + "img/20180815_154807_245.e90d2015.jpg";